/** Desktop window registry: order = icon column order. */
export const WINDOW_IDS = ['profile', 'metrics', 'experience', 'projects', 'stack', 'contact'] as const

export type WindowId = (typeof WINDOW_IDS)[number]

export const WINDOW_META: Record<WindowId, { glyph: string }> = {
  profile: { glyph: '👤' },
  metrics: { glyph: '📊' },
  experience: { glyph: '📁' },
  projects: { glyph: '💻' },
  stack: { glyph: '🎛️' },
  contact: { glyph: '✉️' },
}
